export const closeIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9099 16L27.3499 6.55997C27.7399 6.16997 27.7399 5.53997 27.3499 5.14997C26.9599 4.75997 26.3299 4.75997 25.9399 5.14997L16.4999 14.59L7.05992 5.13997C6.66992 4.74997 6.03992 4.74997 5.64992 5.13997C5.25992 5.52997 5.25992 6.15997 5.64992 6.54997L15.0899 15.99L5.64992 25.43C5.25992 25.82 5.25992 26.45 5.64992 26.84C5.84992 27.04 6.09992 27.13 6.35992 27.13C6.61992 27.13 6.86992 27.03 7.06992 26.84L16.5099 17.4L25.9499 26.84C26.1499 27.04 26.3999 27.13 26.6599 27.13C26.9199 27.13 27.1699 27.03 27.3699 26.84C27.7599 26.45 27.7599 25.82 27.3699 25.43L17.9299 15.99L17.9099 16Z"
      fill="#4C3437"
    />
  </svg>
);

export const hamburgerIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.5 10.6H6.5C5.95 10.6 5.5 10.15 5.5 9.60001C5.5 9.05001 5.95 8.60001 6.5 8.60001H26.5C27.05 8.60001 27.5 9.05001 27.5 9.60001C27.5 10.15 27.05 10.6 26.5 10.6Z"
      fill="#4C3437"
    />
    <path
      d="M26.5 17H6.5C5.95 17 5.5 16.55 5.5 16C5.5 15.45 5.95 15 6.5 15H26.5C27.05 15 27.5 15.45 27.5 16C27.5 16.55 27.05 17 26.5 17Z"
      fill="#4C3437"
    />
    <path
      d="M26.5 23.4H6.5C5.95 23.4 5.5 22.95 5.5 22.4C5.5 21.85 5.95 21.4 6.5 21.4H26.5C27.05 21.4 27.5 21.85 27.5 22.4C27.5 22.95 27.05 23.4 26.5 23.4Z"
      fill="#4C3437"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9321 19.8675L16.2221 15.1575C17.2871 13.86 17.9321 12.195 17.9321 10.3875C17.9321 6.23251 14.5496 2.85001 10.3946 2.85001C6.23961 2.85001 2.84961 6.23251 2.84961 10.3875C2.84961 14.5425 6.23211 17.925 10.3871 17.925C12.1946 17.925 13.8596 17.28 15.1571 16.215L19.8671 20.925C20.0171 21.075 20.2046 21.1425 20.3996 21.1425C20.5946 21.1425 20.7821 21.0675 20.9321 20.925C21.2246 20.6325 21.2246 20.16 20.9321 19.8675ZM4.34961 10.3875C4.34961 7.05751 7.05711 4.35001 10.3871 4.35001C13.7171 4.35001 16.4246 7.05751 16.4246 10.3875C16.4246 13.7175 13.7171 16.425 10.3871 16.425C7.05711 16.425 4.34961 13.7175 4.34961 10.3875Z"
      fill="#4C3437"
    />
  </svg>
);

export const searchCircleIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 0.5C25.0604 0.5 32 7.43959 32 16C32 24.5604 25.0604 31.5 16.5 31.5C7.93959 31.5 1 24.5604 1 16C1 7.43959 7.93959 0.5 16.5 0.5Z"
      fill="white"
    />
    <path
      d="M16.5 0.5C25.0604 0.5 32 7.43959 32 16C32 24.5604 25.0604 31.5 16.5 31.5C7.93959 31.5 1 24.5604 1 16C1 7.43959 7.93959 0.5 16.5 0.5Z"
      stroke="#4C3437"
    />
    <path
      d="M25.4341 23.8675L20.7241 19.1575C21.7891 17.86 22.4341 16.195 22.4341 14.3875C22.4341 10.2325 19.0516 6.85001 14.8966 6.85001C10.7416 6.85001 7.35156 10.2325 7.35156 14.3875C7.35156 18.5425 10.7341 21.925 14.8891 21.925C16.6966 21.925 18.3616 21.28 19.6591 20.215L24.3691 24.925C24.5191 25.075 24.7066 25.1425 24.9016 25.1425C25.0966 25.1425 25.2841 25.0675 25.4341 24.925C25.7266 24.6325 25.7266 24.16 25.4341 23.8675ZM8.85156 14.3875C8.85156 11.0575 11.5591 8.35001 14.8891 8.35001C18.2191 8.35001 20.9266 11.0575 20.9266 14.3875C20.9266 17.7175 18.2191 20.425 14.8891 20.425C11.5591 20.425 8.85156 17.7175 8.85156 14.3875Z"
      fill="#4C3437"
    />
  </svg>
);

export const searchCircleBrownIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#4C3437"
    />
    <path
      d="M24.9321 23.8675L20.2221 19.1575C21.2871 17.86 21.9321 16.195 21.9321 14.3875C21.9321 10.2325 18.5496 6.85001 14.3946 6.85001C10.2396 6.85001 6.84961 10.2325 6.84961 14.3875C6.84961 18.5425 10.2321 21.925 14.3871 21.925C16.1946 21.925 17.8596 21.28 19.1571 20.215L23.8671 24.925C24.0171 25.075 24.2046 25.1425 24.3996 25.1425C24.5946 25.1425 24.7821 25.0675 24.9321 24.925C25.2246 24.6325 25.2246 24.16 24.9321 23.8675ZM8.34961 14.3875C8.34961 11.0575 11.0571 8.35001 14.3871 8.35001C17.7171 8.35001 20.4246 11.0575 20.4246 14.3875C20.4246 17.7175 17.7171 20.425 14.3871 20.425C11.0571 20.425 8.34961 17.7175 8.34961 14.3875Z"
      fill="#FFAFB8"
    />
  </svg>
);
